import React, { useEffect, useState } from "react";
import OfferResponseMain from "src/components/offer-response/OfferResponseMain";

export default function OfferResponsePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <OfferResponseMain />
    </div>
  );
}
